// Project Form Schema for FormBuilder

export const createProjectSchema = {
  initialValues: {
    name: '',
    description: '',
    domain: '',
    project_type: 'website',
    status: 'active',
    start_date: '',
    end_date: '',
    notes: '',
    client_id: ''
  },
  
  validationRules: {
    name: {
      required: true,
      minLength: 2,
      message: 'Το όνομα έργου είναι υποχρεωτικό και πρέπει να έχει τουλάχιστον 2 χαρακτήρες'
    },
    client_id: {
      required: true,
      message: 'Παρακαλώ επιλέξτε πελάτη'
    },
    project_type: {
      required: true,
      message: 'Παρακαλώ επιλέξτε τύπο έργου'
    },
    domain: {
      required: true,
      minLength: 3,
      message: 'Το domain είναι υποχρεωτικό (τουλάχιστον 3 χαρακτήρες)'
    },
    start_date: {
      required: true,
      message: 'Η ημερομηνία έναρξης είναι υποχρεωτική'
    },
    status: {
      required: true,
      message: 'Παρακαλώ επιλέξτε κατάσταση'
    },
  },

  formatters: {
    // Convert empty strings to null for optional fields
    name: (value) => value && value.trim() ? value.trim() : '',
    description: (value) => value && value.trim() ? value.trim() : null,
    domain: (value) => value ? value.trim() : '',
    notes: (value) => value && value.trim() ? value.trim() : null,
    start_date: (value) => value && value.trim() ? value : '',
    end_date: (value) => value && value.trim() ? value : null,
    // Convert client_id to integer
    client_id: (value) => {
      const parsed = parseInt(value);
      return !isNaN(parsed) && parsed > 0 ? parsed : null;
    }
  },
  
  sections: [
    {
      title: 'Βασικά Στοιχεία',
      fields: [
        {
          name: 'project_type',
          label: 'Τύπος Έργου',
          type: 'select',
          required: true,
          size: 6,
          options: [
            { value: 'website', label: 'Website' },
            { value: 'web_application', label: 'Application' }
          ]
        },
        {
          name: 'client_id',
          label: 'Πελάτης',
          type: 'client_select',
          required: true,
          size: 6
        },
        {
          name: 'domain',
          label: 'Domain/URL',
          type: 'text',
          required: true,
          size: 6
        },
        {
          name: 'status',
          label: 'Κατάσταση',
          type: 'select',
          required: true,
          size: 6,
          options: [
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' }
          ]
        }
      ]
    },
    {
      title: 'Λεπτομέρειες',
      fields: [
        {
          name: 'name',
          label: 'Όνομα Έργου',
          type: 'text',
          required: true,
          size: 6 
        },
        {
          name: 'start_date',
          label: 'Ημερομηνία Έναρξης',
          type: 'date',
          required: true,
          size: 6
        },
        {
          name: 'description',
          label: 'Περιγραφή',
          type: 'text',
          multiline: true,
          rows: 3,
          size: 12
        },
        {
          name: 'end_date',
          label: 'Ημερομηνία Λήξης (Προαιρετικό)',
          type: 'date',
          size: 6
        },
        {
          name: 'notes',
          label: 'Σημειώσεις',
          type: 'text',
          multiline: true,
          rows: 3,
          size: 12
        }
      ]
    }
  ]
};

export const updateProjectSchema = {
  ...createProjectSchema,
  // Same schema for updates
};